import React from "react";
import { useSelector } from "react-redux";

interface QuickSearchBackLinkProps {
  children?: React.ReactNode;
}

export const QuickSearchBackLink = ({ children }: QuickSearchBackLinkProps) => {
  return (
    <a className="header__link-block" onClick={() => window.history.back()}>
      {children}
    </a>
  );
};

const QuickSearchToggle = () => {
  const { active } = useSelector((state) => state.quickSearch);

  return (
    <>
      {active ? (
        <QuickSearchBackLink>
          <i className="icon-search"></i>
        </QuickSearchBackLink>
      ) : (
        <a className="header__link-block" href={window.__litium.quickSearchUrl}>
          <i className="icon-search"></i>
        </a>
      )}
    </>
  );
};

export default QuickSearchToggle;
